/* =========================================================================
   TrueLight — theme.js
   Vanilla, scoped, PRESENTATION-ONLY JS. No framework, no build step.
   This whole file is PORTABLE — copy it to Shopify assets/theme.js as-is.
   The design-only preview helpers (section include loader + local nav shim)
   live separately in assets/_preview.js, which you simply do not port.
   See CONVENTIONS.md.

   IMPORTANT: There is NO real cart/checkout here. The buy button and qty are
   styled stand-ins inside [data-slot="product-form"]; Shopify's real
   {% form 'product' %} replaces them on conversion.
   ========================================================================= */
(function () {
  "use strict";

  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  /* ---- Product gallery: one scroll-snap track; thumbs + dots scroll to a
     slide; track scroll position drives the active thumb/dot/counter. */
  function initGallery(root) {
    var track = root.querySelector("[data-gallery-track]");
    var slides = root.querySelectorAll("[data-gallery-slide]");
    var thumbs = root.querySelectorAll("[data-gallery-thumb]");
    var dots = root.querySelectorAll("[data-gallery-dot]");
    var counter = root.querySelector("[data-gallery-count]");
    if (!track || !slides.length) return;

    function goto(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: i * track.clientWidth, behavior: "smooth" });
    }
    function setActive(i) {
      thumbs.forEach(function (t, n) { t.setAttribute("aria-current", n === i ? "true" : "false"); });
      dots.forEach(function (d, n) { d.setAttribute("aria-current", n === i ? "true" : "false"); });
      if (counter) counter.textContent = (i + 1) + " / " + slides.length;
    }
    thumbs.forEach(function (t, i) { t.addEventListener("click", function () { goto(i); }); });
    dots.forEach(function (d, i) { d.addEventListener("click", function () { goto(i); }); });
    track.addEventListener("scroll", function () {
      setActive(Math.round(track.scrollLeft / track.clientWidth));
    }, { passive: true });
    setActive(0);

    // Expose so the variant picker can sync the gallery (best-practice #4).
    root._galleryShow = function (src) {
      slides.forEach(function (s, n) {
        var img = s.querySelector("img");
        if (img && img.getAttribute("src") === src) goto(n);
      });
    };
  }

  /* ---- Lightbox zoom (tap/click + pinch is native on the enlarged image).
     Swipe / drag / arrow keys / nav buttons move between the gallery photos. */
  function initLightbox() {
    var box = document.querySelector("[data-lightbox]");
    if (!box) return;
    var bImg = box.querySelector("img");
    var close = box.querySelector("[data-lightbox-close]");
    var prev = box.querySelector("[data-lightbox-prev]");
    var next = box.querySelector("[data-lightbox-next]");
    var imgs = Array.prototype.slice.call(document.querySelectorAll("[data-zoomable] img"));
    var cur = 0;

    if (imgs.length < 2) { if (prev) prev.hidden = true; if (next) next.hidden = true; }

    function isOpen() { return box.getAttribute("data-open") === "true"; }
    function show(i) {
      cur = (i + imgs.length) % imgs.length;
      bImg.src = imgs[cur].src; bImg.alt = imgs[cur].alt;
    }
    imgs.forEach(function (img, i) {
      img.closest("[data-zoomable]").addEventListener("click", function () {
        show(i);
        box.setAttribute("data-open", "true");
        document.body.style.overflow = "hidden";
      });
    });
    function shut() { box.setAttribute("data-open", "false"); document.body.style.overflow = ""; }
    if (close) close.addEventListener("click", shut);
    if (prev) prev.addEventListener("click", function () { show(cur - 1); });
    if (next) next.addEventListener("click", function () { show(cur + 1); });

    // Swipe (touch) / horizontal drag (mouse) changes photos. Only single-
    // pointer gestures count, so two-finger pinch zoom stays native.
    var startX = null, startY = null, pointers = 0, dragged = false;
    box.addEventListener("pointerdown", function (e) {
      pointers++;
      if (pointers > 1) { startX = null; return; }
      startX = e.clientX; startY = e.clientY; dragged = false;
    });
    box.addEventListener("pointerup", function (e) {
      pointers = Math.max(0, pointers - 1);
      if (startX === null) return;
      var dx = e.clientX - startX, dy = e.clientY - startY;
      startX = null;
      // Any real movement suppresses the tap-to-close that follows the gesture.
      dragged = Math.abs(dx) > 10 || Math.abs(dy) > 10;
      if (imgs.length > 1 && Math.abs(dx) > 48 && Math.abs(dx) > Math.abs(dy) * 1.5) {
        show(dx < 0 ? cur + 1 : cur - 1);
      }
    });
    box.addEventListener("pointercancel", function () { pointers = Math.max(0, pointers - 1); startX = null; });

    box.addEventListener("click", function (e) {
      if (dragged) { dragged = false; return; }
      if (e.target === box || e.target === bImg) shut();
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") shut();
      if (!isOpen()) return;
      if (e.key === "ArrowRight") show(cur + 1);
      else if (e.key === "ArrowLeft") show(cur - 1);
    });
  }

  /* ---- Variant picker (presentation only; updates label, price, gallery) */
  function initVariants(root) {
    // Price/label may sit outside [data-product]; scope to the whole buy box.
    var scope = root.closest(".pdp-buybox") || document;
    var groups = root.querySelectorAll("[data-option-group]");
    groups.forEach(function (group) {
      var label = group.querySelector("[data-option-selected]");
      var btns = group.querySelectorAll("[data-variant]");
      btns.forEach(function (btn) {
        btn.addEventListener("click", function () {
          if (btn.hasAttribute("disabled")) return;
          btns.forEach(function (b) { b.setAttribute("aria-pressed", "false"); });
          btn.setAttribute("aria-pressed", "true");
          if (label) label.textContent = btn.getAttribute("data-variant");

          // Reflect price (best-practice: keep price in sync with variant).
          var price = btn.getAttribute("data-price");
          var was = btn.getAttribute("data-compare");
          var priceEl = scope.querySelector("[data-price-now]");
          var wasEl = scope.querySelector("[data-price-was]");
          if (price && priceEl) priceEl.textContent = price;
          if (was && wasEl) wasEl.textContent = was;

          // Auto-update gallery image for the variant (best-practice #4).
          var img = btn.getAttribute("data-image");
          var gallery = document.querySelector("[data-gallery]");
          if (img && gallery && gallery._galleryShow) gallery._galleryShow(img);

          // Keep the sticky bar price in sync.
          var sbPrice = document.querySelector("[data-stickybar] [data-sb-price]");
          if (price && sbPrice) sbPrice.textContent = price;
        });
      });
    });
  }

  /* ---- Quantity stepper. Wired globally (PDP buy box + cart lines). */
  function initQty(root) {
    root.querySelectorAll("[data-qty]").forEach(function (qty) {
      if (qty._qtyBound) return;
      qty._qtyBound = true;
      var input = qty.querySelector("input");
      if (!input) return;
      var min = parseInt(input.getAttribute("min"), 10);
      if (isNaN(min)) min = 1;
      function set(v) {
        input.value = Math.max(min, v);
        // Notify listeners (the cart line updater listens for this).
        input.dispatchEvent(new Event("change", { bubbles: true }));
      }
      var dec = qty.querySelector("[data-qty-dec]");
      var inc = qty.querySelector("[data-qty-inc]");
      if (dec) dec.addEventListener("click", function () { set((parseInt(input.value, 10) || min) - 1); });
      if (inc) inc.addEventListener("click", function () { set((parseInt(input.value, 10) || min) + 1); });
    });
  }

  /* ---- Cart line quantity updates (Cart AJAX API, then reload to re-render totals). */
  function initCart() {
    var cart = document.querySelector('[data-section="main-cart"]');
    if (!cart) return;
    var timer;
    cart.addEventListener("change", function (e) {
      var input = e.target.closest && e.target.closest('input[name="updates[]"]');
      if (!input) return;
      var lineEl = input.closest(".cart-line");
      var allLines = Array.prototype.slice.call(cart.querySelectorAll(".cart-line"));
      var line = allLines.indexOf(lineEl) + 1; // Shopify cart lines are 1-based
      if (line < 1) return;
      var qty = Math.max(0, parseInt(input.value, 10) || 0);
      cart.setAttribute("aria-busy", "true");
      // Debounce so rapid +/- clicks coalesce into one request + one reload.
      clearTimeout(timer);
      timer = setTimeout(function () {
        var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
        fetch(base + "cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", "Accept": "application/json" },
          body: JSON.stringify({ line: line, quantity: qty })
        }).then(function () { window.location.reload(); })
          .catch(function () { window.location.reload(); });
      }, 350);
    });
  }

  /* ---- Accordions (secondary detail only) */
  function initAccordions() {
    document.querySelectorAll("[data-acc-trigger]").forEach(function (trigger) {
      trigger.addEventListener("click", function () {
        var open = trigger.getAttribute("aria-expanded") === "true";
        trigger.setAttribute("aria-expanded", open ? "false" : "true");
        var panel = document.getElementById(trigger.getAttribute("aria-controls"));
        if (panel) panel.setAttribute("data-open", open ? "false" : "true");
      });
    });
  }

  /* ---- Sticky mobile Add-to-Cart: hidden at top, reveals once the user
     starts scrolling, then stays visible for the rest of the page. */
  function initStickyBar() {
    var bar = document.querySelector("[data-stickybar]");
    if (!bar) return;
    var threshold = 40; // px scrolled before the bar appears
    function reveal() {
      if (window.pageYOffset <= threshold) return;
      bar.setAttribute("data-show", "true");
      bar.setAttribute("aria-hidden", "false");
      bar.inert = false;
      window.removeEventListener("scroll", reveal);
    }
    window.addEventListener("scroll", reveal, { passive: true });
    reveal(); // handle loads that restore a scrolled position (e.g. back nav)
  }

  /* ---- Mobile nav toggle */
  function initNav() {
    var burger = document.querySelector("[data-nav-toggle]");
    var nav = document.querySelector("[data-mobile-nav]");
    if (burger && nav) burger.addEventListener("click", function () {
      var open = nav.getAttribute("data-open") === "true";
      nav.setAttribute("data-open", open ? "false" : "true");
    });
  }

  /* ---- Hero background parallax (presentation-only, opt-in via [data-parallax]) */
  function initParallax() {
    if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    document.querySelectorAll("[data-parallax]").forEach(function (el) {
      if (el.dataset.parallaxBound) return;
      el.dataset.parallaxBound = "1";
      var hero = el.closest(".hero") || el.parentElement;
      var ticking = false;
      function update() {
        var rect = hero.getBoundingClientRect();
        if (rect.bottom > 0 && rect.top < window.innerHeight) {
          el.style.transform = "translate3d(0," + (window.scrollY * 0.22) + "px,0)";
        }
        ticking = false;
      }
      function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
      window.addEventListener("scroll", onScroll, { passive: true });
      window.addEventListener("resize", onScroll, { passive: true });
      update();
    });
  }

  /* ---- Email pop-ups -----------------------------------------------------
     Two parts: (1) generic open/close wiring for any [data-popup], and
     (2) a frequency-capped auto trigger for the site-wide email capture
     ([data-tl-auto="true"]). Timing + cooldown come from the section's
     data-* attributes; the Liquid section already suppresses itself for
     signed-in customers and on cart/account pages. */
  function initPopups() {
    function open(p) {
      if (p.getAttribute("data-open") === "true") return;
      p.setAttribute("data-open", "true");
      document.body.style.overflow = "hidden";
      var c = p.querySelector("[data-popup-close]");
      if (c) { try { c.focus(); } catch (e) {} }
    }
    function shut(p) {
      p.setAttribute("data-open", "false");
      document.body.style.overflow = "";
    }

    document.querySelectorAll("[data-popup]").forEach(function (p) {
      p.querySelectorAll("[data-popup-close]").forEach(function (c) {
        c.addEventListener("click", function () { shut(p); });
      });
      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape" && p.getAttribute("data-open") === "true") shut(p);
      });
    });

    // Manual triggers (e.g. a "Get 10% off" link) can still open a popup by id.
    document.querySelectorAll("[data-popup-open]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var p = document.querySelector('[data-popup="' + btn.getAttribute("data-popup-open") + '"]');
        if (p) open(p);
      });
    });

    initEmailPopup(open);
  }

  /* Decide WHEN the email capture appears, and how often. */
  function initEmailPopup(open) {
    var p = document.querySelector('[data-popup][data-tl-auto="true"]');
    if (!p) return;

    function ls(op, k, v) {
      try { return op === "get" ? localStorage.getItem(k) : localStorage.setItem(k, v); }
      catch (e) { return null; }
    }

    // Never nag people who already subscribed...
    if (ls("get", "tl_email_subscribed") === "1") return;
    // ...or who dismissed it inside the cooldown window...
    var days = parseInt(p.getAttribute("data-frequency-days"), 10) || 10;
    var dismissedAt = parseInt(ls("get", "tl_email_dismissed_at"), 10);
    if (dismissedAt && (Date.now() - dismissedAt) < days * 86400000) return;
    // ...or more than once per browsing session.
    try { if (sessionStorage.getItem("tl_popup_shown") === "1") return; } catch (e) {}

    function markDismissed() { ls("set", "tl_email_dismissed_at", String(Date.now())); }
    p.querySelectorAll("[data-popup-close]").forEach(function (c) {
      c.addEventListener("click", markDismissed);
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && p.getAttribute("data-open") === "true") markDismissed();
    });

    var fired = false, timer;
    function onExit(e) { if (e.clientY <= 0 && !e.relatedTarget) fire(); }
    function onScroll() {
      var h = document.documentElement;
      if ((h.scrollTop + window.innerHeight) / h.scrollHeight * 100 >= scrollPct) fire();
    }
    function fire() {
      if (fired) return;
      fired = true;
      if (timer) clearTimeout(timer);
      document.removeEventListener("mouseout", onExit);
      window.removeEventListener("scroll", onScroll);
      try { sessionStorage.setItem("tl_popup_shown", "1"); } catch (e) {}
      open(p);
    }

    // Trigger 1: after a delay on the page.
    var delay = parseInt(p.getAttribute("data-delay"), 10);
    if (!isNaN(delay) && delay > 0) timer = setTimeout(fire, delay * 1000);

    // Trigger 2: exit intent, desktop pointers only, armed after a short grace.
    if (p.getAttribute("data-exit-intent") === "true" &&
        window.matchMedia && window.matchMedia("(pointer: fine)").matches) {
      setTimeout(function () { document.addEventListener("mouseout", onExit); }, 3000);
    }

    // Trigger 3: scroll depth.
    var scrollPct = parseInt(p.getAttribute("data-scroll-percent"), 10);
    if (!isNaN(scrollPct) && scrollPct > 0) {
      window.addEventListener("scroll", onScroll, { passive: true });
    }
  }

  /* Every email capture form (footer, newsletter band, pop-up) shares a honeypot.
     Drop bot submissions, and optimistically flag real ones so the pop-up stops
     showing to someone who just signed up anywhere on the site. */
  function initCaptureForms() {
    document.addEventListener("submit", function (e) {
      var form = e.target;
      if (!form || !form.querySelector) return;
      var hp = form.querySelector('input[name="contact[hp_website]"]');
      if (!hp) return;
      if (hp.value) { e.preventDefault(); return; }
      try { localStorage.setItem("tl_email_subscribed", "1"); } catch (err) {}
    }, true);
  }

  function boot() {
    document.querySelectorAll("[data-gallery]").forEach(initGallery);
    document.querySelectorAll("[data-product]").forEach(initVariants);
    initQty(document);
    initCart();
    initLightbox();
    initAccordions();
    initStickyBar();
    initNav();
    initParallax();
    initPopups();
    initCaptureForms();
  }

  // Bind on load. In Liquid this is all that runs (sections are server-rendered).
  // In local preview, _preview.js re-calls window.TrueLight.boot() once the
  // design-only includes have been fetched in.
  ready(boot);
  window.TrueLight = { boot: boot };
})();
